import * as React from 'react';
import './App.css';
import StripeHTML from "./components/StripeElementsHTML";
import Banner from "./components/banner";
import {StripeProvider} from "./components/stripe/useStripe";
import {SubscriptionProvider} from "./components/StripeElementsHTML/components/subscription/SubscriptionWindow";

function App() {
    const searchParams = new URLSearchParams(window.location.search);
    const isBannerPage = searchParams.get('banner') === '1';

    if (isBannerPage) {
        return <Banner />;
    }

    return (
        <StripeProvider>
            <SubscriptionProvider>
                <StripeHTML/>
            </SubscriptionProvider>
        </StripeProvider>
    );
}

export default App;
